import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    { path: "market", lazy: page(() => import("./MarketPage")), handle: shows("market", "cards") },
    {
      path: "market/auctions/:auctionId",
      lazy: page(() => import("./AuctionDetailPage")),
      handle: shows("market", "cards"),
    },
    { path: "market/sell", lazy: page(() => import("./SellPage")), handle: shows("market", "cards") },
    { path: "market/mine", lazy: page(() => import("./MyMarketPage")), handle: shows("market", "trades") },
    { path: "market/trades", lazy: page(() => import("./TradesPage")), handle: shows("trades", "cards") },
    {
      path: "market/trades/new",
      lazy: page(() => import("./TradeComposePage")),
      handle: shows("trades", "cards"),
    },
    {
      path: "market/trades/:tradeId",
      lazy: page(() => import("./TradeDetailPage")),
      handle: shows("trades", "cards"),
    },
    // `/trades…` redirect here from app/redirects.tsx (lane 0a).
  ],
};
